import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {SelectItem} from 'primeng/api';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-multiselect',
    template: `
        <p-multiSelect [class.ng-dirty]="showError"
                       [placeholder]="to.placeholder"
                       [options]="to.options"
                       [formControl]="formControl"
                       [formlyAttributes]="field"
            ngDefaultControl>
        </p-multiSelect>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldMultiSelect extends FieldType {
}
